(function () {
  'use strict';

  function countryCodeToFlag(countryCode) {
    return String(countryCode || '')
      .trim()
      .toUpperCase()
      .replace(/[A-Z]/g, function (character) {
        return String.fromCodePoint(127397 + character.charCodeAt(0));
      });
  }

  function enhanceMarketIndicator() {
    var form = document.getElementById('localization_form_header_currency');

    if (!form || form.dataset.accuEnhanced === 'true') {
      return;
    }

    var input = form.querySelector('input[name="country_code"]');
    var button = form.querySelector('.header__action-item-link');
    var value = form.querySelector('.currency-selector__value');

    if (!input || !button || !value) {
      return;
    }

    var countryCode = input.value;
    var currencyMatch = value.textContent.match(/\b[A-Z]{3}\b/);
    var countryName = value.textContent.replace(/\s*\(.*/, '').trim();
    var flag = document.createElement('span');

    flag.className = 'accu-market-flag';
    flag.setAttribute('aria-hidden', 'true');
    flag.textContent = countryCodeToFlag(countryCode);
    value.dataset.currency = currencyMatch ? currencyMatch[0] : countryCode;
    value.textContent = value.dataset.currency;
    button.setAttribute('aria-label', countryName + ', currency ' + value.dataset.currency + '. Change country or region');
    button.insertBefore(flag, value);
    form.dataset.accuEnhanced = 'true';
  }

  function enhanceStoreLocatorIframe() {
    var container = document.getElementById('lifter-store-locator');

    if (!container || container.dataset.accuEnhanced === 'true') {
      return;
    }

    function labelIframe() {
      var iframe = container.querySelector('iframe');

      if (!iframe) {
        return false;
      }

      if (!iframe.title) {
        iframe.title = 'Accusize distributor map and location search';
      }

      container.dataset.accuEnhanced = 'true';
      return true;
    }

    container.setAttribute('role', 'region');
    container.setAttribute('aria-label', 'Accusize distributor locator');

    if (!labelIframe()) {
      var observer = new MutationObserver(function () {
        if (labelIframe()) {
          observer.disconnect();
        }
      });

      observer.observe(container, { childList: true, subtree: true });
    }
  }

  function enhanceStickyHeader() {
    var section = document.querySelector('.shopify-section__header');

    if (!section) {
      return;
    }

    if (window.__accuStickyHeaderSection === section) {
      if (window.__accuStickyHeaderUpdate) {
        window.__accuStickyHeaderUpdate();
      }
      return;
    }

    if (window.__accuStickyHeaderCleanup) {
      window.__accuStickyHeaderCleanup();
    }

    var desktop = window.matchMedia('(min-width: 1000px)');
    var frame = 0;

    function updateHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', section.clientHeight + 'px');
    }

    function render() {
      frame = 0;

      // `offsetTop` follows the scroll position once a `position: sticky`
      // element is pinned, so it cannot be used as a stable threshold here.
      // The header starts at the top of the storefront; a small scroll guard
      // avoids compacting on incidental sub-pixel movement.
      var compact = desktop.matches && window.scrollY > 8;

      section.classList.toggle('accu-header--compact', compact);
      window.requestAnimationFrame(updateHeaderHeight);
    }

    function requestRender() {
      if (!frame) {
        frame = window.requestAnimationFrame(render);
      }
    }

    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender);

    if (desktop.addEventListener) {
      desktop.addEventListener('change', requestRender);
    } else {
      desktop.addListener(requestRender);
    }

    window.__accuStickyHeaderSection = section;
    window.__accuStickyHeaderUpdate = requestRender;
    window.__accuStickyHeaderCleanup = function () {
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', requestRender);

      if (desktop.removeEventListener) {
        desktop.removeEventListener('change', requestRender);
      } else {
        desktop.removeListener(requestRender);
      }

      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    };

    requestRender();
  }

  function redirectSuccessfulContactForm() {
    var successMessage = document.querySelector('[data-contact-success-redirect]');

    if (!successMessage || successMessage.dataset.accuRedirected === 'true') {
      return;
    }

    var redirectUrl = successMessage.getAttribute('data-contact-success-redirect');

    if (!redirectUrl) {
      return;
    }

    successMessage.dataset.accuRedirected = 'true';
    window.location.replace(redirectUrl);
  }

  function revealSuccessfulAnnouncementNewsletter() {
    var newsletter = document.getElementById('announcement-bar-newsletter');

    if (!newsletter) {
      return;
    }

    var successMessage = newsletter.querySelector('.alert--success');
    var toggle = document.querySelector('.announcement-bar__button[data-action="toggle-newsletter"]');

    if (!successMessage || !toggle || toggle.getClientRects().length === 0) {
      return;
    }

    successMessage.setAttribute('role', 'status');
    successMessage.setAttribute('aria-live', 'polite');

    if (toggle.getAttribute('aria-expanded') === 'false') {
      toggle.click();
    }
  }

  function monitorSearchaniseResults() {
    var searchanisePath = '/pages/search-results-page';

    if (window.location.pathname.slice(-searchanisePath.length) !== searchanisePath) {
      return;
    }

    var root = document.documentElement;
    var searchParams = new URLSearchParams(window.location.search);
    var query = searchParams.get('q');

    if (!query || root.dataset.accuSearchFallbackState) {
      return;
    }

    var observer;
    var timeout;

    function searchaniseIsReady() {
      var results = document.querySelector('#snize_results.snize-search-results');

      return Boolean(results && results.querySelector('.snize-main-panel, .snize-no-products-found'));
    }

    function stopMonitoring(state) {
      if (observer) {
        observer.disconnect();
      }

      if (timeout) {
        window.clearTimeout(timeout);
      }

      root.dataset.accuSearchFallbackState = state;
    }

    function redirectToNativeSearch() {
      var routes = window.routes || {};
      var nativeSearchUrl = new URL(routes.searchUrl || '/search', window.location.origin);

      stopMonitoring('redirecting');
      nativeSearchUrl.searchParams.set('q', query);
      nativeSearchUrl.searchParams.set('type', 'product');
      nativeSearchUrl.searchParams.set('options[prefix]', 'last');
      window.location.replace(nativeSearchUrl.toString());
    }

    if (searchParams.get('accu_search_fallback_test') === '1') {
      root.dataset.accuSearchFallbackState = 'testing';
      window.setTimeout(redirectToNativeSearch, 0);
      return;
    }

    if (searchaniseIsReady()) {
      root.dataset.accuSearchFallbackState = 'healthy';
      return;
    }

    root.dataset.accuSearchFallbackState = 'watching';
    observer = new MutationObserver(function () {
      if (searchaniseIsReady()) {
        stopMonitoring('healthy');
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    timeout = window.setTimeout(function () {
      if (searchaniseIsReady()) {
        stopMonitoring('healthy');
        return;
      }

      redirectToNativeSearch();
    }, 8000);
  }

  function enhanceStorefront() {
    enhanceMarketIndicator();
    enhanceStickyHeader();
    enhanceStoreLocatorIframe();
    redirectSuccessfulContactForm();
    revealSuccessfulAnnouncementNewsletter();
    monitorSearchaniseResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceStorefront);
  } else {
    enhanceStorefront();
  }

  document.addEventListener('shopify:section:load', enhanceStorefront);
  window.addEventListener('pageshow', enhanceStorefront);
})();
